"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var password_reset_init_service_1 = require("./password-reset-init.service");
var mixpanel_service_1 = require("@logbook/core/tracking/mixpanel.service");
var mixpanel_event_enum_1 = require("@logbook/core/tracking/mixpanel-event.enum");
var operators_1 = require("rxjs/operators");
var PasswordResetInitComponent = /** @class */ (function () {
    function PasswordResetInitComponent(passwordResetInitService, elementRef, renderer, mixpanel) {
        this.passwordResetInitService = passwordResetInitService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.mixpanel = mixpanel;
        this.isLoading = false;
    }
    PasswordResetInitComponent.prototype.ngOnInit = function () {
        this.resetAccount = {};
    };
    PasswordResetInitComponent.prototype.ngAfterViewInit = function () {
        // this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    PasswordResetInitComponent.prototype.requestReset = function () {
        var _this = this;
        if (this.resetAccount.email) {
            this.error = null;
            this.mixpanel.track(mixpanel_event_enum_1.MixpanelEvent.PASSWORD_FORGOT, {
                username: this.resetAccount.email
            });
            this.isLoading = true;
            this.passwordResetInitService.save(this.resetAccount).pipe(operators_1.first()).subscribe(function () {
                _this.success = 'OK';
                _this.isLoading = false;
            }, function (err) {
                _this.success = null;
                _this.isLoading = false;
                if (err && err.body.message) {
                    _this.error = err.body.message;
                }
                else {
                    _this.error = 'Cannot reset password. Please try later or contact Teamlogs';
                }
            });
        }
    };
    return PasswordResetInitComponent;
}());
exports.PasswordResetInitComponent = PasswordResetInitComponent;
